module.exports = "/_next/static/images/ec330aba95308a4e7b84fc0947752216-about-us-hero.jpg";